import { gql } from '@apollo/client';

export const verifyUserGQL = gql`
  query verifyUser($token: String!) {
    verifyUser(token: $token) {
      user {
        _id
        username
        firstName
        lastName
        state
        phone
      }
    }
  }
`;
